import styled from "styled-components";

export default function Loading({ color }) {
  return (
    <Container>
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <Circle cx="12" cy="12" r="3.2" color={color} />
      </svg>
    </Container>
  );
}

const Container = styled.div``;
const Circle = styled.circle`
  fill: ${({ color }) => (color ? color : "red")};
`;
